export const privacyHtml = (logo) => {
    return (`
    <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Votiamo App - Privacy Policy</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0;
            background-color: #f9f9f9;
            color: #333;
        }
        header {
            text-align: center;
            padding: 20px 0;
            background-color: #fff;
        }
        header img {
            width: 150px;
            height: auto;
        }
        header h1 {
            margin: 10px 0 0;
            font-size: 24px;
            color: #0073a6;
        }
        main {
            padding: 20px;
            max-width: 90%;
            margin: 20px auto;
        }
        h2 {
            color: #005580;
            margin-top: 20px;
        }
        h3 {
            color: #333;
            margin-top: 15px;
        }
        p {
            margin: 10px 0;
        }
        ul {
            margin: 10px 0 20px;
            padding-left: 20px;
        }
        footer {
            text-align: center;
            padding: 10px 0;
            font-size: 12px;
            color: #777;
        }
        .highlight {
            font-weight: bold;
            color: #0073a6;
        }
    </style>
</head>
<body>
    <header>
        <img src="${logo}" alt="Votiamo App Logo">
        <h1>Votiamo App - Privacy Policy</h1>
    </header>
    <main>
        <h2>Introduction</h2>
        <p>We wish to inform you that Il Cavedio Società Cooperativa, owner of the Votiamo brand, with legal
and administrative headquarters at Via De Cristoforis 12, 21100 Varese (VA), in its capacity as
Data Controller pursuant to EU Regulation 2016/679 (GDPR or Applicable Law), recognizes the
importance of protecting personal data and considers its safeguarding one of the main objectives
of its activities. In compliance with the Applicable Law, we provide you with the necessary
information regarding the processing of personal data you have provided. This notice is given
pursuant to the Applicable Law, and the Data Controller invites you to read it carefully as it
contains important information about the protection of personal data and the security measures
adopted to ensure confidentiality in full compliance with the Applicable Law. Il Cavedio Società
Cooperativa informs you that the processing of personal data will be based on principles of
lawfulness, correctness, transparency, purpose limitation and storage, data minimization,
accuracy, integrity, and confidentiality. Therefore, personal data will be processed in accordance
with the legislative provisions of the Applicable Law and the confidentiality obligations provided
therein.</p>
        
        <h2>Definitions</h2>
        <ul>
            <li><span class="highlight">"Personal data"</span>:  any information relating to an identified or identifiable natural person ("data
subject"); an identifiable natural person is one who can be identified, directly or indirectly, in
particular by reference to an identifier such as a name, an identification number, location data, an
online identifier, or to one or more factors specific to the physical, physiological, genetic, mental,
economic, cultural, or social identity of that natural person.</li>
            <li><span class="highlight">"Processing"</span>:any operation or set of operations performed on personal data or on sets of
personal data, whether or not by automated means, such as collection, recording, organization,
structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by
transmission, dissemination or otherwise making available, alignment or combination, restriction,
erasure, or destruction.</li>
            <li><span class="highlight">"Health data"</span>: personal data related to the physical or mental health of a natural person, including the provision of health care services, which reveal information about their health status.</li>
        </ul>

        <h2>Place of Data Processing</h2>
        <p>Data processing takes place at the aforementioned headquarters of the Data Controller, at any operational sites (where courses are held), and at third parties identified by the Data Controller.</p>
        
        <h2>Types of Data Processed</h2>
        <p>The processing concerns personal and identification data provided by the data subject (for example but not limited to: name, surname, address, VAT number, tax code, landline or mobile phone number, email address, bank details, etc.).</p>

        <h2>Purposes, Legal Basis, and Mandatory or Optional Nature of Processing</h2>
        <p>The personal data provided will be processed by the Data Controller for the following purposes:</p>
        <h3>a) Administrative-accounting purposes</h3>
        <p>For the application of data protection provisions,
processing for administrative-accounting purposes is connected to the performance of
organizational, administrative, financial, and accounting activities, regardless of the nature of the
processed data. In particular, these purposes include internal organizational activities, activities
functional to fulfilling contractual and pre-contractual obligations, managing the relationship in all
its phases, maintaining accounting records, and applying tax, trade union, social security-welfare,
health, hygiene, and workplace safety regulations.</p>
        <h3>b) Informational and promotional purposes</h3>
        <p>The use of the provided email addresses is allowed
for sending information and newsletters. The data subject, at the time of collection and during
each communication, is informed of the possibility of opposing the processing at any time, easily
and free of charge. To unsubscribe from the mailing list, it is sufficient to write an email at any time to the company's email address or send a letter to the Data Controller's physical address
(headquarters) with the subject "unsubscribe mailing list".</p>

        <h2>Methods of Processing – Data Storage</h2>
        <p>The processing will be carried out in an automated and manual form, with methods and tools
aimed at ensuring maximum security and confidentiality, by persons specifically appointed as
processors and handlers pursuant to the applicable regulations. Data will be stored for a period
not exceeding the purposes for which the data were collected and subsequently processed, and
in any case during the existence of the contractual or commercial relationship.</p>

 <h2>SCOPE OF COMMUNICATION AND DISSEMINATION</h2>
        <p>The data processed will not be disseminated, unless explicitly authorized by the data subject after
suitable information. However, data may be communicated to companies contractually linked to
the Data Controller and, where necessary, also to subjects inside and outside the European
Union, in accordance with and within the limits of the GDPR. Data may be communicated in this
sense to third parties belonging to the following categories:</p>

<ul>
    <li>Subjects providing services for the management of the information system used by the Data
Controller and telecommunications networks, and who handle the maintenance of the
technological part (website, mobile application, email, and newsletter service).</li>
    <li>Professionals, studios, or companies in the context of assistance and consultancy relationships.</li>
    <li>The company IL Cavedio SSD a RL, a partner of Il Cavedio Società Cooperativa, with whom it
shares the customer database.</li>
    <li>Subjects performing control, auditing, and certification of activities carried out by the Data
Controller.</li>
    <li>Competent authorities for fulfilling legal obligations and/or provisions of public bodies, upon
their request.</li>
</ul>
<p>The identification data processed in application of corporate security procedures are not subject
to communication, except for express and specific requests possibly made by competent judicial
and investigative authorities. Any further communication or dissemination will occur only after the
explicit consent of the data subject. Additionally, during ordinary processing activities, persons
expressly designated by us as processors and/or handlers, authorized according to their
respective profiles, may access and thus become aware of personal and identification data.</p>

<h2>NATURE OF PROVISION AND REFUSAL</h2>
<p>Regarding the data we are obliged to know in order to fulfill obligations arising from existing
contracts and obligations provided by laws, regulations, community legislation, or provisions
issued by authorities legitimated by law and supervisory and control bodies, failure to provide
them will make it impossible to establish or continue the relationship, within the limits in which
such data are necessary for its execution.</p>
<p>Providing data to allow the Data Controller to send commercial communications is optional; the
data subject may oppose processing at any time by exercising the rights provided by the
Applicable Law in the forms and ways indicated herein.</p>
<p>The Data Controller also informs that any non-communication or incorrect communication of any
mandatory information has the following consequences:</p>
<ul>
    <li>The impossibility for the Data Controller to ensure the adequacy of the processing itself to the
contractual agreements for which it is executed.</li>
    <li>The possible non-correspondence of the processing results to the obligations imposed by tax,
administrative, and civil legislation to which it is addressed.</li>
</ul>


       <section>
    <h2>Details on the Use of Data in the Mobile Application</h2>
    <p>At Votiamo, we are committed to protecting your privacy and ensuring the security of your personal data. This section outlines the types of data we collect—both directly from you and via Meta (Facebook Login)—as well as how we use and safeguard your information.</p>

    <h3>Required Personal Data (Collected During Signup):</h3>
    <p>When you create an account on Votiamo, we may collect the following details:</p>
    <ul>
        <li>Date of birth</li>
        <li>Gender</li>
        <li>City of residence</li>
        <li>Family status</li>
        <li>Education level</li>
    </ul>
    <p>Please note: We do not require any official documents to verify the above details.</p>

    <h3>Data Collected via Meta (Facebook Login):</h3>
    <p>If you choose to sign in using Meta (Facebook Login), we may collect the following information, as permitted by Meta's user consent flow:</p>
    <ul>
        <li>Public profile information (name, profile picture, Facebook ID)</li>
        <li>Email address</li>
        <li>Locale and timezone</li>
    </ul>
    <p>This data is used to create and manage your account, personalize your experience, and streamline the login process across Votiamo platforms.</p>

    <h3>Use of Collected Data:</h3>
    <ul>
        <li>To create and manage your Votiamo account</li>
        <li>To conduct statistical analysis of survey results</li>
        <li>To personalize your experience and display relevant content</li>
        <li>To improve app performance and engagement features</li>
        <li>To ensure compliance with legal and platform requirements</li>
    </ul>

    <p>We do not sell, rent, or share your personal information with third parties without your explicit consent, except as required by law.</p>
</section>

<section>
    <h2>Data Deletion Policy</h2>
    <p>We are committed to respecting your privacy and ensuring you have control over your personal data. If you wish to delete your account, here's how it works on our platform:</p>
    
    <ul>
        <li>
            <strong>a. In-App Deletion:</strong>  
            You can initiate the deletion of your account directly within the app by going to <em>Settings</em> and selecting <em>"Delete Account."</em> This action will deactivate your account immediately and mark your data for future deletion.
        </li>
        <li>
            <strong>b. Temporary Deactivation Period:</strong>  
            After requesting deletion, your account enters a <strong>3-month deactivation period</strong>. During this time, your data is not permanently removed—you can reactivate your account anytime within these 3 months by simply logging back in.
        </li>
        <li>
            <strong>c. Permanent Deletion:</strong>  
            If no reactivation occurs within the 3-month window, your account and all associated personal data will be <strong>permanently deleted</strong> from all Votiamo platforms and databases. Once this final deletion is processed, your data cannot be recovered.
        </li>
        <li>
            <strong>d. Support Requests:</strong>  
            If you're unable to delete or reactivate your account through the app, you can reach out to us at <a href="mailto:support@votiamo.com">support@votiamo.com</a> with your request. Please include relevant account details for verification.
        </li>
    </ul>
</section>


<h3>Privacy Controls:</h3>
<ul>
    <li>Visibility Settings: You have the option to hide any or all of your personal information from other
users using our privacy features.</li>
    <li>Private Participation: You can choose to participate in surveys privately. In this mode, your
responses cannot be associated with your account by other users; only the survey creator can
see your answers linked to your profile.</li>
    <li>Anonymous Participation: If the survey creator allows it, you can participate anonymously. This
ensures that neither other users nor the survey creator can associate your responses with your
account.</li>
</ul>

<h3>Survey Access Restrictions:</h3>
<p>Survey creators have the ability to limit participation based on the provided personal
characteristics. For example, they can create surveys exclusively for residents of certain cities or
specific demographic groups. This helps target the desired audience for more relevant results.</p>

<h3>Protection of Contact Information:</h3>
<p>Your contact details—specifically your email address and phone number—are strictly confidential:</p>
<ul>
    <li>Non-Disclosure: Under no circumstances will your contact information be made visible to other
users or communicated to survey creators.</li>
    <li>Data Security: We employ robust security measures to protect your contact information from
unauthorized access or disclosure.</li>
</ul>

<h3>Summary:</h3>
<ul>
    <li>Users participating in surveys non-anonymously expose their information only to the survey
creator, not to other participants.</li>
    <li>You have full control over your data and can adjust your privacy settings at any time.</li>
    <li>Under no circumstances are your contacts communicated to the survey creator or other users.</li>
    <li>Our priority is to ensure your privacy and protect your personal information throughout your
experience with Votiamo.</li>
</ul>

<p>If you have questions or need further clarification on how your data are used, please contact our
support team. Your privacy is our top priority, and we are here to assist you with any concerns.</p>

        <h2>Rights of the Data Subject</h2>
        <p>We inform you that at any time you may exercise your rights towards the Data Controller pursuant to the Applicable Law, thus obtaining confirmation of the existence or not of such data, knowing their content and origin, verifying their accuracy, requesting their integration, updating, or rectification. Under the conditions provided by the Applicable Law, you have the right to request rectification and deletion, limitation of processing, portability, as well as to oppose, for legitimate reasons, their processing. Requests should be sent via email to the Data Processor at info@ilcavedio.coop</p>

        <p><strong>Date:</strong> September 1, 2024</p>
        <p><strong>Data Controller:</strong> Il Cavedio Società Cooperativa</p>

    </main>

   
    <footer>
        <p>&copy; 2026 Il Cavedio Società Cooperativa. All rights reserved.</p>
    </footer>
</body>
</html>
    `)
};